import { Widget } from "../../../models/configuration/definitions/widget";

export function getWidgetKey(widget: Widget): string | undefined {
  if (!widget.type || !widget.id) {
    return undefined;
  }
  return `${widget.type} - ${widget.id}`;
}
